const actions = {
  LIST_PRODUCTO: 'LIST_PRODUCTO',
  LIST_PRODUCTO_SELECTBOX: 'LIST_PRODUCTO_SELECTBOX',
  CREATE_PRODUCTO: 'CREATE_PRODUCTO',
  READ_PRODUCTO: 'DREA_PRODUCTO',
  UPDATE_PRODUCTO: 'UPDATE_PRODUCTO',
  DELETE_PRODUCTO: 'DELETE_PRODUCTO',
  
  productoList: data => {  
    return {
      type: actions.LIST_PRODUCTO,
      data,
    };
  },

  productoListSelectBox: data => {
    return {
      type: actions.LIST_PRODUCTO_SELECTBOX,
      data,
    };
  },

  productoCreate: data => {
    return {
      type: actions.CREATE_PRODUCTO,
      data,
    };
  },

  productoRead: data => {
    return {
      type: actions.READ_PRODUCTO,
      data,
    };
  },

  productoUpdate: data => {
    return {
      type: actions.UPDATE_PRODUCTO,
      data,
    };
  },

  productoDelete: () => {
    return {
      type: actions.DELETE_PRODUCTO,      
    };
  },
  

};

export default actions;
